"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _TextLoop = _interopRequireDefault(require("./components/TextLoop"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _TextLoop["default"];
exports["default"] = _default;